import { ReactNode, useCallback, useState } from 'react';
import { GrantInfoHelpPanel } from '../components/events/createEvent/components/GrantInfoHelpPanel';
import { ShiftTypeInfoHelpPanel } from '../components/events/createEvent/components/ShiftTypeInfoHelpPanel';

type PanelId = 'grant' | 'shiftType';

const PANELS: Record<PanelId, () => ReactNode> = {
  grant: () => <GrantInfoHelpPanel />,
  shiftType: () => <ShiftTypeInfoHelpPanel />,
};

export function useWizardToolsPanel() {
  const [toolsOpen, setToolsOpen] = useState(false);
  const [panelId, setPanelId] = useState<PanelId>('grant');

  const openPanel = useCallback((id: PanelId) => {
    setPanelId(id);
    setToolsOpen(true);
  }, []);

  const close = useCallback(() => setToolsOpen(false), []);

  const openGrantPanel = useCallback(() => openPanel('grant'), [openPanel]);
  const openShiftTypePanel = useCallback(() => openPanel('shiftType'), [openPanel]);

  const onToolsChange = useCallback(
    ({ detail }: { detail: { open: boolean } }) => setToolsOpen(detail.open),
    []
  );

  return {
    toolsOpen,
    toolsHide: !toolsOpen,
    tools: PANELS[panelId](),
    onToolsChange,
    openGrantPanel,
    openShiftTypePanel,
    close,
  };
}
